import styled from 'styled-components';

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 60vh;
  margin: 20px auto 0 auto;
  overflow: hidden;
  margin-bottom: 0;
  border-radius: ${({ theme }) => theme.borderRadius.large};

  @media (max-width: 768px) {
    margin-top: 0;
    border-radius: 0;
  }
`;

export const SlideContainer = styled.div<{ active: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
`;

export const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
`;

export const ImageTitle = styled.h2`
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 500;
  z-index: 3;
  text-align: right;
  max-width: 80%;

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.4rem 0.8rem;
    bottom: 4rem;
  }
`;

export const NavButton = styled.button<{ direction: 'prev' | 'next' }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ direction }) => (direction === 'next' ? 'right: 2rem' : 'left: 2rem')};
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.3);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-left: 2px solid white;
    border-bottom: 2px solid white;
    transform: translate(-50%, -50%)
      rotate(${({ direction }) => (direction === 'prev' ? '45deg' : '225deg')});
  }
`;

export const Dots = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.5rem;
  z-index: 3;
`;

export const Dot = styled.button<{ active: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.primary : 'rgba(255, 255, 255, 0.5)'};
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ active, theme }) =>
      active ? theme.colors.primary : 'rgba(255, 255, 255, 0.8)'};
  }
`;

export const ContentWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
  padding: 2rem 0;
  z-index: 2;
`;
